<template>
  <div class="home">
    <div>
      <swiper
        dots-position="center"
        :auto="true"
        :loop="true"
        style="height: 4rem !important;"
      >
        <swiper-item
          class="swiper-demo-img"
          v-for="(item, index) in bannerList"
          :key="item.id"
          @click.native="bannerClick(item)"
        >
          <img :src="item.picUrl" />
        </swiper-item>
      </swiper>
      <!--NAV-->
      <home-nav></home-nav>
      <!--直播预告-->
      <div class="home-living">
        <home-title :title-obj="liveTitle">
          <home-live-list
            slot="content"
            :living-course="liveList"
          ></home-live-list>
          <!--<home-list-for-img-and-text slot="content"></home-list-for-img-and-text>-->
        </home-title>
      </div>
      <!--更多资讯-->
      <!-- <home-headline-list slot="content" :list="headlineList"></home-headline-list> -->
      <div class="home_conent">
        <!--热门课程-->
        <div @touchmove="preLoad(getPre)">
          <home-title :title-obj="hotCourse">
            <home-hot-course-list
              slot="content"
              :list="indexHotList"
            ></home-hot-course-list>
          </home-title>
        </div>
        <p
          style="text-align:center;margin-top: 1rem"
          v-show="!indexHotList.length"
        >
          <inline-loading></inline-loading>
          <span
            style="vertical-align:middle;display:inline-block;font-size:.19rem;"
          >
            &nbsp;&nbsp;加载中
          </span>
        </p>
        <!-- 动画弹层 -->
        <animation-window :send-dir="sendDir"></animation-window>
      </div>
    </div>
    <AppDownload />
  </div>
</template>
<script>
// TODO: vux
import { Swiper, SwiperItem } from 'vux';
import HomeNav from './components/Nav.vue';
import HomeTitle from '@/components/Title.vue';
import HomeHeadlineList from './components/SwiperInformation.vue';
import HomeLiveList from './components/LiveList.vue';
import HomeHotCourseList from './components/CourseZoneList.vue';
import AnimationWindow from './components/AnimationWindow.vue';
import { home, zone } from '@/api/ajax';
import { loadMore } from '@/Mixin/loadMore.js';
import { mapState, mapMutations } from 'vuex';
import AppDownload from './components/AppDownload.vue';
import registerService from '@/services/register.js';

export default {
  name: 'Home',
  mixins: [loadMore],
  data() {
    return {
      isHttps: false,
      liveTitle: {
        //直播预告
        img:
          'http://cdn.yxvzb.com/newWechat/image/%E9%A6%96%E9%A1%B5-%E5%8C%BB%E5%AD%A6V%E7%9B%B4%E6%92%AD@2x.png',
        leftName: '医学V视界',
        rightName: '更多直播',
        type: 0,
        path: 'liveTrailer',
        needRight: 1
      },
      informationTitle: {
        //
        img:
          'http://cdn.yxvzb.com/newWechat/image/%E9%A6%96%E9%A1%B5-%E4%B8%93%E5%B1%9E%E5%A4%B4%E6%9D%A1@2x.png',
        leftName: '专属头条',
        rightName: '更多资讯',
        type: 0,
        path: 'headlineList'
      },
      hotCourse: {
        //
        img:
          'http://cdn.yxvzb.com/newWechat/image/%E9%A6%96%E9%A1%B5-%E7%83%AD%E9%97%A8%E8%AF%BE%E7%A8%8B@2x.png',
        leftName: '热门课程',
        rightName: '',
        type: 0,
        path: 'courseList',
        needRight: 0
      },
      bannerList: [],
      liveList: [],
      headlineList: [],
      indexHotList: [],
      params: {
        pageNo: 2, // 初始化为1 此次为下次
        pageSize: 20
      },
      loadFlag: false,
      inter: null,
      startClientY: 0,
      endClientY: 0,
      sendDir: 0, // 给弹层内容发送指令，或上或下
      beforeS: 0,
      nextS: 0,
      scrollTime: null
    };
  },
  methods: {
    ...mapMutations(['ISBUTTONACTIVE']),
    scrollPage() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.beforeS = scrollTop;
      this.scrollTime = setTimeout(() => {
        this.nextS = scrollTop;
        // console.log(this.beforeS, this.nextS);
        if (this.beforeS == 0 && this.nextS == 0) {
          this.sendDir = 2;
        } else {
          if (this.beforeS - this.nextS < 0) {
            this.sendDir = 2;
          } else if (this.beforeS == this.nextS) {
            this.sendDir = 0;
          } else {
            this.sendDir = 1;
          }
        }
      }, 200);
    },
    bannerClick(item) {
      //小程序中banner 不跳转
      this.$sa.re_click({
        target_name: 'banner', // 点击目标名字
        target_contentname: item.name, //点击目标的标题
        target_contentid: item.id, //点击目标的id
        target_contenturl: item.web_url //点击目标的url
      });
      if (!this.isHttps) {
        if (/yxvzb\.com|jimijiayuan\.cn/.test(item.web_url)) {
          this.$sa.setSaSession_href(this.$route, item.web_url);
        } else {
          location.href = item.web_url;
        }
      }
    },
    getList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        home.indexHotList(data).then(res => {
          // console.log(res.data);
          for (var i = 0; i < res.data.data.list.length; i++) {
            this.indexHotList.push(res.data.data.list[i]);
          }
          if (res.data.data.list.length < 20) {
            this.loadFlag = false;
            return false;
          }
          this.params.pageNo += 1;
          this.loadFlag = true;
        });
      }
    },
    getPre() {
      this.getList(this.params);
    }
  },
  computed: {
    ...mapState({
      isButtonActive: state => state.isButtonActive
    })
  },
  components: {
    HomeNav,
    Swiper,
    SwiperItem,
    HomeTitle,
    HomeHeadlineList,
    HomeLiveList,
    HomeHotCourseList,
    AnimationWindow,
    AppDownload
  },
  created() {
    // 自动注册来源于聚合SaaS的用户
    registerService.call(this);

    if (this.isButtonActive) {
      this.ISBUTTONACTIVE('');
    }
    this.isHttps = this.$config.protocol === 'https';

    home.indexBannerCategory().then(res => {
      this.bannerList = res.data.data;
      // console.log(this.bannerList);
    });
    home.indexLivingCourse().then(res => {
      this.liveList = res.data.data;
    });

    home.indexList().then(res => {
      let result = [];
      let arr = res.data.data.list;
      for (let i = 0, len = arr.length; i < len; i += 4) {
        result.push(arr.slice(i, i + 4));
      }
      this.headlineList = result;
      // console.log(this.headlineList);
      // this.headlineList = res.data.data
    });
    //window.addEventListener('scroll', this.preLoad());

    /*
     * 热门课程+专区
     * */
    let zoneParams = {
      pageNo: 1,
      pageSize: 5
    };
    let homeParams = {
      pageNo: 1,
      pageSize: 20
    };
    // 混合视频与专区
    this.$http
      .all([home.indexHotList(homeParams), home.indexChannel(zoneParams)])
      .then(
        this.$http.spread((homeData, zoneData) => {
          // console.log(homeData.data);
          let homeIndex = 0;
          // 如果后面的视频多 则下拉加载
          if (homeData.data.data.list.length > 19) {
            this.loadFlag = true;
          }

          // 混合数据 优先专区 4个视频1个专区一组
          zoneData.data.data.list.filter((item, index) => {
            this.indexHotList.push({
              id: item.id,
              courseName: item.title,
              coverPicUrl: item.bgUrl,
              isZone: true,
              subNum: item.subNum,
              hospitalName: '',
              duties: '',
              userName: '',
              externalLink: item.externalLink
            });
            if (index) {
              homeIndex = index * 4;
            }
            for (let i = homeIndex; i < homeIndex + 4; i++) {
              if (homeData.data.data.list[i]) {
                this.indexHotList.push(
                  Object.assign(homeData.data.data.list[i], {
                    isZone: false
                  })
                );
              }
            }
          });
        })
      );
  },
  mounted() {
    // window.addEventListener('touchmove', this.preLoad)
    //todo 进入首页SC *

    let wxUserInfo = this.$api.getStorage('wxUserInfo');
    sa.track(
      'wx_shouye',
      {
        pageUrl: location.href,
        client_id: wxUserInfo.id || wxUserInfo.wxOpenId || '',
        web_edition: 2
      },
      function() {}
    );
    window.addEventListener('scroll', this.scrollPage);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollPage);
    clearTimeout(this.scrollTime);
    this.scrollTime = null;
  }
};
</script>
<style lang="less">
.home {
  position: relative;
  .vux-indicator-center {
    bottom: 0.2rem !important;
  }
  .vux-slider > .vux-indicator {
    bottom: 0.2rem !important;
  }
  .vux-icon-dot {
    background: rgba(255, 255, 255, 0.4);
  }
  .active {
    width: 0.2933rem !important;
    height: 0.133rem !important;
    background-color: #027cfa !important;
    /*border-radius: .1rem .07rem .1rem .1rem !important;*/
  }
}
</style>
<style lang="less" scoped>
.swiper-demo-img {
  img {
    max-width: 100%;
    height: 4rem !important;
  }
}

.home_conent {
  padding: 0 0.43rem;
}
.home-living {
  padding: 0 0.43rem;
  border-bottom: 0.19rem solid #f4f4f4;
}
</style>
